import type { RouteRecordRaw, NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useMeStore } from '@/stores/me'

const requireAuth = (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext,
) => {
    const meStore = useMeStore()

    meStore.restoreSession()

    if (meStore.isAuthenticated) {
        next()
    } else {
        next({ name: 'investors-login' })
    }
}
export const ipbFormRoutes: RouteRecordRaw[] = [
    {
        name: 'investors-ipbForms-edit',
        path: '/InvestmentProposalForm/ipb-forms/:formId/edit',
        component: () => import('./[formId].vue'),
        beforeEnter: requireAuth,
        props: true,
    },
    {
        name: 'investors-ipbForms-new',
        path: '/InvestmentProposalForm/ipb-forms/new',
        component: () => import('./new.vue'),
        beforeEnter: requireAuth,
    },
]
